/**
 * Every word the interface says, gathered from the three files that hold them.
 *
 * Split by screen rather than kept in one table, because that is the split that
 * lets two people edit the catalogue at once without landing on the same lines.
 * Merged here so that lookup stays a single flat map: a key is a key, and no
 * caller needs to know which screen first needed it.
 */

import { common } from "./common";
import { library } from "./library";
import { reader } from "./reader";

export const messages = {
  en: { ...common.en, ...library.en, ...reader.en },
  fr: { ...common.fr, ...library.fr, ...reader.fr },
};
